import { DriverCertificationCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_certification_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';

type DriverCertificationAddedDetailProps = {
  event: DriverCertificationCreatedEvent;
};

export const DriverCertificationAddedDetail = ({
  event,
}: DriverCertificationAddedDetailProps) => {
  const certification = event.driverCertification;

  if (!certification) {
    return (
      <Col className="@DriverCertificationAddedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@DriverCertificationAddedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Driver</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="Driver ID" value={certification.driverId?.value} />
        </div>
      </Col>

      <Col
        className="rounded-md border border-success/20 bg-success/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-success/80">
          Added Certification
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={certification.id?.value} />
          <FieldDisplay label="Type" value={certification.type} />
          <FieldDisplay label="Number" value={certification.number} />
          <FieldDisplay
            label="Issuing Body"
            value={certification.issuingBody}
          />
          <FieldDisplay
            label="Issued Date"
            value={protoTimestampToZonedDateTimeString(
              certification.issuedDate,
            )}
          />
          <FieldDisplay
            label="Expiration Date"
            value={protoTimestampToZonedDateTimeString(
              certification.expirationDate,
            )}
          />
        </div>
      </Col>
    </Col>
  );
};
